// src/pages/Terms.jsx
import React from "react";
import Navigation from "../components/Common/header/Navigation";
import Footer from "../components/Common/footer/Footer";
import "../styles/Pages.css"; // Keep this for the overall page shell and layout
import "../styles/Terms.css"; // The new dedicated terms styling!

const Terms = () => {
    return (
        <div className="page-shell">
            <Navigation />
            <section className="page-section">
                <div className="container" style={{ maxWidth: "800px" }}>
                    <h1 className="page-section-title" style={{ marginBottom: "60px" }}>Terms and Conditions</h1>

                    {/* Replaced 'page-prose' with 'terms-content' */}
                    <div className="terms-content">
                        <p>Before placing an order, customers are responsible for reading our Terms and Conditions. By completing a purchase, you acknowledge and accept these terms. All sales are final for both standard and customised items.</p>
                        <p>All orders which breach our sale terms of conditions by involving fraudulent activity or unjust chargebacks will be pursued legally until funds are recovered.</p>

                        <h3>1. Processing Times</h3>
                        <ul>
                            <li>Standard delivery times are typically 3–7 working days.</li>
                            <li>Custom or pre-order items (including coloured bundles and specific frontals such as deep-coloured or water-wavy textures): 10 working days.</li>
                            <li>Order processing begins immediately after purchase. Due to the hygienic nature of hair extensions, orders cannot be changed, cancelled, or refunded once processing has begun.</li>
                            <li>Any cancellation accepted prior to processing is at our discretion and may be subject to a 15% administrative fee, depending on the item type.</li>
                            <li><strong>For hygiene reasons, opened or used hair products are non-returnable and non-refundable.</strong></li>
                        </ul>

                        <h3>2. Delivery Estimates & Shipping</h3>
                        <p>We ship via Royal Mail, DPD, and DHL. All UK orders are dispatched within our standard processing timeframe. Once dispatched, delivery typically takes 3–7 business days. You will receive shipping confirmation and tracking details via email once your order has been processed and dispatched.</p>
                        <p>Customers must ensure all personal and delivery details are entered accurately, as orders cannot be amended once dispatched.</p>
                        <p>Bundle Madness will not be held responsible for delays caused by postal services, courier networks, adverse weather conditions, or UK public holidays.</p>

                        <h3>3. Returns and Refunds</h3>
                        <p>We maintain a strict quality control process to ensure our customers receive only premium-quality hair.</p>
                        <ul>
                            <li>Items must remain in pristine condition, with the curl pattern undisturbed and suitable for resale.</li>
                            <li>Returns or exchanges will not be accepted if the seal holding the hair has been untied or cut.</li>
                            <li>For products with lace, returns or exchanges are not accepted if the item has been worn, styled, cut, or altered.</li>
                        </ul>
                        <p>If you are dissatisfied due to a confirmed product defect, we will offer a full refund or an exchange for an item of equal value following assessment. To be eligible, returns must be received within 14 days of the delivery date. Hair must remain unused, unworn, unwashed, and in its original packaging. Customers are responsible for return shipping costs unless the item is confirmed to be faulty.</p>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default Terms;